module.exports = __webpack_public_path__ + "img/Compassion.8de4f803.png";